// * Converts a raw notification count to a display string.
// * Returns undefined for 0 (so the CSS badge attribute is unset and hidden),
// * '9+' for counts above the single-digit display cap, or the stringified number otherwise.
export const getBadgeDisplayValue = (count: number): string | undefined => {
  if (count === 0) {
    return undefined;
  }

  if (count > 9) {
    return '9+';
  }

  return String(count);
};
